import { memo } from "react";
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import {
    OnboardingApplicationStep,
    OnboardingApplication,
    onboardingApplicationStepAndFieldStatus,
    ECommerceOnboardingApplication
} from "consts/onboarding";
import {
    StepLabel,
    useApplicationDetailContext,
    type StepLabelProps
} from "ui/organizms/Onboarding/Applications/common";

const BusinessInformationLabel = (props: Partial<StepLabelProps>) => {
    const { getStepData } = useApplicationDetailContext();

    const data = getStepData(ECommerceOnboardingApplication.BusinessInformation);

    return (
        <StepLabel
            to={`${OnboardingApplicationStep[OnboardingApplication.ECommerce].BusinessInformation}`}
            Icon={ShoppingBagOutlinedIcon}
            {...onboardingApplicationStepAndFieldStatus.get(data.status)}
            {...props}
        >
            Business Information
        </StepLabel>
    );
};

export default memo(BusinessInformationLabel);
